import { Typography } from '@mui/material';
import React from 'react';

import { OkDlg } from '../../../../general/dialogs/ok-dlg';

type Props = {
  onClose: () => void;
};

const ResumeApplicationDlg: React.FC<Props> = ({ onClose }: Props) => {
  return (
    <OkDlg
      content={
        <>
          <Typography color="textSecondary" align="center">
            You have an application in progress.
          </Typography>
          <Typography color="textSecondary" align="center">
            Picking up where you left off!
          </Typography>
        </>
      }
      okLabel="Continue"
      onOk={onClose}
      onClose={onClose}
      title="Resuming application"
    />
  );
};

export { ResumeApplicationDlg };
